import Header from "../TableHeader/TableHeader";
import useDataTable from "../../hooks/useDataTable";
import FormModal from "../FormModal";
import { Props } from "./index";
import DeleteModal from "../DeleteModal";

const DataTable = ({
  title,
  columns,
  formFields,
  useGetQuery,
  useUpdateMutation,
  useCreateMutation,
  useRemoveMutation,
  modify,
  hasDelete,
  hasCreate,
  customRefetch,
  type,
  hostId,
}: Props) => {
  const { DataTable, hasSelected, refetch, selectedRowKeys } = useDataTable({
    columns,
    useGetQuery,
    useRemoveMutation,
    modify,
    hasDelete,
    type,
    hostId,
  });
  return (
    <>
      {modify && (
        <FormModal
          formFields={formFields}
          refetch={refetch}
          customRefetch={customRefetch}
          useUpdateMutation={useUpdateMutation}
          title={title}
        />
      )}
      {hasDelete && (
        <DeleteModal
          formFields={formFields}
          refetch={refetch}
          customRefetch={customRefetch}
          useRemoveMutation={useRemoveMutation}
          title={title}
        />
      )}
      <Header
        refetch={refetch}
        useAdd={useCreateMutation}
        hasSelected={hasSelected}
        selectedRowKeys={selectedRowKeys}
        title={title}
        hasDelete={hasDelete}
        hasCreate={hasCreate}
        formFields={formFields}
        useRemoveMutation={useRemoveMutation}
        modify={modify}
      />
      <DataTable />
    </>
  );
};

export default DataTable;
